import { Flex } from 'antd';

export interface COCModalMessageProps {
  selectedShipments: number;
  statusUpdateCount: number;
  podCount: number;
  shipments_with_pod: number;
  userEmail?: string;
  exportStatusUpdate?: boolean;
  exportPODs?: boolean;
  themeText?: string;
}

export const getCOCModalMessage = ({
  selectedShipments,
  statusUpdateCount,
  podCount,
  shipments_with_pod,
  userEmail,
  exportStatusUpdate,
  exportPODs,
  themeText,
}: COCModalMessageProps & {
  exportStatusUpdate: boolean;
  exportPODs: boolean;
}) => {
  const showNoPodsMessage = podCount === 0; // Flow D + E when no PODs are available
  const POD_final_count = exportPODs ? podCount : 0;

  const showSomePodsMessage =
    exportPODs && podCount > 0 && shipments_with_pod < selectedShipments; // Flow B
  const showSummary = exportStatusUpdate || (exportPODs && podCount > 0); // Always show summary
  // final count is based on after user select or de-select options
  const finalCount =
    (exportStatusUpdate ? statusUpdateCount : 0) + (exportPODs ? podCount : 0);

  const pluralize = (count: number, singular: string) =>
    `${count} ${count === 1 ? singular : singular + 's'}`;

  return (
    <Flex
      vertical
      gap={20}
      style={{
        fontSize: 16,
      }}
    >
      {showNoPodsMessage && (
        <p>
          {pluralize(selectedShipments, 'shipment')} selected. No PODs are
          available yet for the selected{' '}
          {selectedShipments === 1 ? 'shipment' : 'shipments'}.
        </p>
      )}

      {showSomePodsMessage && (
        <p>
          {pluralize(selectedShipments, 'shipment')} selected. PODs available
          for {pluralize(shipments_with_pod, 'shipment')}.
        </p>
      )}

      {showSummary && (
        <p>
          You’re about to export {finalCount}{' '}
          {finalCount === 1 ? 'PDF' : 'PDFs'} (
          {`${exportStatusUpdate ? statusUpdateCount : 0} ${themeText} + ${pluralize(POD_final_count, 'POD')}`}
          )
          {finalCount > 200 && userEmail
            ? `. A link will be sent to your email (${userEmail}) when it’s ready.`
            : ' in a single ZIP file.'}
        </p>
      )}
    </Flex>
  );
};
